import { render } from "./PayrollDetails.vue?vue&type=template&id=5658739c&scoped=true"
import script from "./PayrollDetails.vue?vue&type=script&lang=js"
export * from "./PayrollDetails.vue?vue&type=script&lang=js"

import "./PayrollDetails.vue?vue&type=style&index=0&id=5658739c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5658739c"]])

export default __exports__